function getServerURL() {
  const localhost = 'http://localhost:3123'
  const staging = ''
  const production = 'https://whatsapp-server.cloudxier.com'

  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }

  let env
  switch (host) {
    case 'project-tracker.cloudxier.dev':
      env = staging
      break;
    case 'https://project-tracker.cloudxier.dev':
      env = staging
      break;
    case 'whatsapp.cloudxier.com':
      env = production
      break;
    case 'https://whatsapp.cloudxier.com':
      env = production
      break;
    default:
      env = localhost
  }
  return env
};

export default getServerURL
